import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AuthenticationDialog } from '@components';

interface ConnectFirstProps {}

export function ConnectFirst(props: Readonly<ConnectFirstProps>) {
  const { t } = useTranslation('authentication');
  const { search } = useLocation();

  return (
    <Stack
      width="100%"
      maxWidth="sm"
      py={5}
      justifyContent="center"
      alignItems="flex-start"
      spacing={3}
      divider={<Divider flexItem />}
    >
      <Stack spacing={1} width="100%">
        <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" fontWeight="bold">
            {t('loginFirst.Before continuing')}
          </Typography>
        </Stack>
        <Typography variant="h6">
          {t('loginFirst.To reference your spot you need to be logged in.')}
        </Typography>
        <Typography variant="subtitle2">
          {t(
            `loginFirst.If you don't already have an account, you can create one by clicking the button just below and then "I sign up" or by using Apple or Google.`
          )}
        </Typography>
      </Stack>
      <AuthenticationDialog
        redirect={'/register/spot' + search}
        button={
          <Button fullWidth variant="contained" size="large">
            {t('signin or signup', { ns: 'cta' })}
          </Button>
        }
      />
    </Stack>
  );
}
